import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from '@reach/router';
import { TRY_RISK_FREE } from '../../../../constants/Paths';
import {
  BACKGROUND_BLACK,
  BLACK,
  ORANGE,
  WHITE,
} from '../../../../styles/Colors';
import { HEADER_HIGHT } from '../../../../styles/LayoutSetting';
import { mobileDevice } from '../../../../constants/DeviceBreakPoints';

const styles = theme => ({
  screenContainer: {
    backgroundColor: WHITE,
    paddingTop: HEADER_HIGHT,
    minHeight: '100vh',
  },
  mainRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: `calc(100vh - ${2 * HEADER_HIGHT}px)`,
    width: '100%',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 24,
      minHeight: `calc(90vh - ${2 * HEADER_HIGHT}px)`,
    },
  },
  titleContainer: {
    backgroundColor: BACKGROUND_BLACK,
    minHeight: HEADER_HIGHT,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.down(mobileDevice)]: {
      minHeight: '10vh',
    },
  },
  contentContainer: {
    backgroundColor: BACKGROUND_BLACK,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  mainText: {
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: 1.2,
    marginTop: 30,
    padding: '30px 20px',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 24,
    },
  },
  descriptionText: {
    color: BLACK,
    fontSize: 24,
    textAlign: 'center',
    padding: '4px 30px',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
  introductionTitleText: {
    fontFamily: 'Poppins, sans-serif',
    color: ORANGE,
    fontSize: 30,
    fontWeight: 'bold',
    textAlign: 'center',
    lineHeight: 1.2,
    margin: '20px 0',
    padding: '0 20px',
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 18,
      padding: '0 10px',
      margin: '30px 0 10px 0',
    },
  },
  introductionText: {
    fontFamily: 'Quicksand, sans-serif',
    color: WHITE,
    fontSize: 18,
    textAlign: 'center',
    margin: '20px 0',
    padding: '0 30px',
    maxWidth: 900,
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
      textAlign: 'left',
      margin: '10px 0',
    },
  },
  navItem: {
    color: BLACK,
    fontSize: 18,
    fontWeight: 'bold',
    textDecoration: 'none',
    borderRadius: 10,
    padding: '8px 20px',
    margin: '24px 0',
    textAlign: 'center',
    backgroundColor: ORANGE,
    '&:hover': {
      color: WHITE,
    },
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
    },
  },
});

const introductionText = [
  'LinkedField’s one-of-a-kind VIRTUAL PROJECT MANAGER is an intelligent virtual mentor for every project team member.',
  [
    'It ensures the project is set up for success and no time is wasted on “busy or manual work”.',
    'LinkedField’s VIRTUAL PROJECT MANAGER is powered by our proprietary Insights Engine',
    'which frees up the Project Manager’s and Superintendent’s time.',
  ].join(' '),
  [
    'It’s equipping every team member with an extra 10 years of construction experience and',
    'giving back extra hours every week to work on what matters.',
  ].join(' '),
];

const IntroductionSection = ({
  classes,
}) => (
  <div className={classes.screenContainer}>
    <div className={classes.mainRowContainer}>
      <div>
        <div className={classes.mainText}>
          Intelligent Subcontractor Management
        </div>
        <div className={classes.descriptionText}>
          Closing the shortcomings and knowledge gaps
        </div>
        <div className={classes.descriptionText}>
          in construction office and field teams
        </div>
      </div>
      <Link
        className={classes.navItem}
        to={TRY_RISK_FREE}
      >
        Get Started
      </Link>
    </div>
    <div className={classes.titleContainer}>
      <div className={classes.introductionTitleText}>
        Virtual Project Manager In Your Pocket
      </div>
    </div>
    <div className={classes.contentContainer}>
      {introductionText.map(content => (
        <div
          key={content}
          className={classes.introductionText}
        >
          {content}
        </div>
      ))}
    </div>
  </div>
);

IntroductionSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IntroductionSection);
